








import { Component, Vue, Prop } from 'vue-property-decorator';
import * as APITypes from '@/controllers/api/types';

@Component
export default class Commit extends Vue {
  @Prop() private readonly data!: APITypes.Commit;
  private readonly date: Date = new Date(this.data.commit.author.date);
}
